import { useColumnResizeAndReorder as useBase } from "@tailormed/common-client/component/ColumnResizeAndReorder/useColumnResizeAndReorder";

const ICON_COLUMN_KEYS = ["star", "edit", "hasConflicts", "actions"];

const useColumnResizeAndReorder = (viewKey, fixedColumnKeys = []) =>
  useBase(viewKey, fixedColumnKeys, {
    iconColumnKeys: ICON_COLUMN_KEYS
  });

export default useColumnResizeAndReorder;
